module.exports = __webpack_public_path__ + "img/multiplier.a9e077bd.png";